import { useSelector, useDispatch } from 'react-redux';
import { CHeader, CToggler, CHeaderBrand } from '@coreui/react';
import { getCurrentUser } from '@aws-amplify/auth';
import { useEffect, useState } from 'react';


const TheHeader = () => {
  const dispatch = useDispatch();
  const sidebarShow = useSelector((state) => state.sidebarShow);
  const [currentUser, setCurrentUser] = useState(null);
    useEffect(() => {
    const fetchUser = async () => {
      try {
        const user = await getCurrentUser();
        setCurrentUser(user);
      } catch (error) {
        setCurrentUser(null);
      }
    };
    fetchUser();
  }, []);
  const toggleSidebarMobile = () => {
    const val = [false, 'responsive'].includes(sidebarShow) ? true : 'responsive';
    dispatch({ type: 'set', sidebarShow: val });
  };

  return (
    <CHeader className="sed-om-header">
      <CToggler
        inHeader
        className="ml-md-3 d-lg-none"
        onClick={toggleSidebarMobile}
      />

      <CHeaderBrand className="mx-auto" to="/">
        <div className="sed-om-header-site">
          <p className="title">機器制御型DR（EQ）管理システム
</p>
        </div>
      </CHeaderBrand>


      <div className="sed-om-header-name px-3">
        {  currentUser?.signInDetails?.['loginId'] &&
          <p className="name">顧客名 : {currentUser?.signInDetails?.['loginId']}</p>
        }
      </div>

    </CHeader>
  );
};

export default TheHeader;
